import { Component, h } from '@stencil/core';

@Component({
  tag: 'utrecht-icon-nieuw-huis',
  styleUrl: "../../icon/generated.scss",
  shadow: true,
})
export class UtrechtIconNieuwHuis {

  render() {
    return (
      <svg viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg" fill="currentColor" height="1em" width="1em">
  <path d="M19.98 9.35c.07-.43.12-.87.12-1.32 0-4.97-4.54-8.89-9.71-7.87C7.3.77 4.81 3.22 4.16 6.29c-.86 4.08 1.39 7.76 4.82 9.16V9.08a2.499 2.499 0 0 1-1.39-3.02c.23-.8.9-1.45 1.7-1.66 1.68-.45 3.19.8 3.19 2.4 0 1.02-.62 1.89-1.5 2.28l.03 10.77-7.68 6.92c-.4.36-.44.98-.09 1.39l.02.03c.38.44 1.05.47 1.46.06l.24-.24.03 7c0 .55.45 1 1 1h12.04a.99.99 0 0 0 1-1l-.03-7 .23.23a1 1 0 0 0 1.47-.07 1 1 0 0 0-.1-1.38l-7.62-6.88v-3.9c1.32-.16 2.6-.66 3.64-1.38l2.12 1.3c.27.17.6.19.9.08l1.15-.46 1.22.89v.97c0 .34.17.65.45.84l1.2.78c.27.18.62.21.92.09l1.16-.46 1.22.89v.97c0 .35.18.67.48.85l1.3.8a1 1 0 0 0 .92.07l2.71-1.16c.37-.16.61-.52.61-.92v-1.62c0-.33-.17-.65-.45-.83L19.96 9.36Zm-6 19.64v1a.993.993 0 0 1-1 1.01h-2c-.55 0-1-.45-1-1v-1c0-.55.45-1 1-1h1.99c.55 0 1 .44 1 .99Z"/>
</svg>

    );
  }
}
